export function requestStoryNotificationPermission() {
  if (typeof Notification === "undefined" || Notification.permission !== "default") return;
  void Notification.requestPermission();
}

export function notifyInBackground(title: string, body: string, tag: string) {
  if (typeof Notification === "undefined" || Notification.permission !== "granted") return;
  if (document.visibilityState === "visible") return;
  try {
    const notification = new Notification(title, { body, tag, lang: "ru" });
    notification.onclick = () => { window.focus(); notification.close(); };
  } catch { /* уведомление не должно ломать основной сценарий */ }
}
